import type { FC } from 'react';
import {
  Card,
  Table,
  TableHead,
  TableRow,
  Box,
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';
import { numberToMillons } from 'src/utils/functions';

interface PropsAvanceMensualComposicion {
  content: {
    data: any;
    header: { monthPrev: string; monthBest: string };
    pages: { total: number; current: number; limit: number };
    resume: { facturacion: number; facturacionPrev: number; facturacionBest: number; porcPrevMonth: number; porcBestMonth: number; };
  };
  handleChangePage: (event: unknown, page: number) => Promise<void>;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
}

const AvanceMensualComposicion: FC<PropsAvanceMensualComposicion> = ({
  content,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const title = 'Composición de Facturación Comparativo Mes Anterior y Mejor mes, En MM de PEN';
  return (
    <Box>
      <Title title={title} />
      <Card>
        <Scrollbar>
          <Table size="small" className="zoomin">
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic>Convenio</TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Facturación
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Mes anterior
                  <br />
                  {content.header.monthPrev}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Desfase mes Anterior
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Semaforo mes Anterior
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Mejor mes
                  <br />
                  {content.header.monthBest}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Desfase mejor mes
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableBody>
              {content.data.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.convenio}</TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.facturacion)}
                  </TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.facturacionPrev)}
                  </TableCell>
                  <TableCell align="center">
                    {item.porcPrevMonth}
                    %
                  </TableCell>
                  <TableCell align="center">
                    <img
                      src={`/static/images/${item.semaforo}.png`}
                      alt={item.semaforo}
                    />
                  </TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.facturacionBest)}
                  </TableCell>
                  <TableCell align="center">
                    {item.porcBestMonth}
                    %
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  {numberToMillons(content.resume.facturacion)}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  {numberToMillons(content.resume.facturacionPrev)}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right" />
                <TableCellHeaderBasic align="center">
                  {content.resume.porcPrevMonth}
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  {numberToMillons(content.resume.facturacionBest)}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  {content.resume.porcBestMonth}
                  %
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 15, 20]}
                  labelRowsPerPage="Registros por página"
                  labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                  count={content.pages.total}
                  page={content.pages.current}
                  rowsPerPage={content.pages.limit}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
};

export default AvanceMensualComposicion;
